// extracted by mini-css-extract-plugin
export default {"body":"resultBox_body__xXZWF"};